module.exports = __webpack_public_path__ + "static/media/whale.bc8fa2f7.svg";